import React from 'react';
import { useTranslation } from 'react-i18next';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SimpleHoverPopperPopover from '@wix/da-ds/pkg/popper/presets/SimpleHoverPopperPopover';
export var PremiumIconWithPopover = function (_a) {
    var isPaidFolder = _a.isPaidFolder, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement(SimpleHoverPopperPopover, { className: className, popoverContent: isPaidFolder
            ? t('deviationview.paywall.literature.premiumFolder.tooltip')
            : t('deviationview.paywall.literature.watchersOnly.tooltip') }, isPaidFolder ? (React.createElement(Premium, { size: IconSize.SMALL })) : (React.createElement(EyeDisc2, { size: IconSize.SMALL }))));
};
PremiumIconWithPopover.displayName = 'PremiumIconWithPopover';
export default PremiumIconWithPopover;
//# sourceMappingURL=PremiumIconWithPopover.js.map